import React from 'react';

import { DashboardCard } from './DashboardCard';
import { TeamMemberRow } from './TeamMemberRow';
import type { TeamMemberInfo } from './useDashboardTeamMembers';

interface TeamActivityCardProps {
  members: TeamMemberInfo[] | null;
  loading: boolean;
  error: boolean;
  groupSlug: string;
  collapseButton?: React.ReactNode;
  collapsed?: boolean;
}

export function TeamActivityCard({
  members,
  loading,
  error,
  groupSlug,
  collapseButton,
  collapsed,
}: TeamActivityCardProps): React.ReactNode {
  const memberCount = members?.length ?? 0;
  const settingsUrl = groupSlug ? `/team/${groupSlug}/settings` : undefined;

  return (
    <DashboardCard
      title="Team Activity"
      badge={memberCount}
      linkText={settingsUrl ? 'Team Settings' : undefined}
      linkTo={settingsUrl}
      loading={loading}
      error={error}
      collapseButton={collapseButton}
      collapsed={collapsed}
    >
      {members && members.length > 0 ? (
        <div className="flex flex-col">
          <p className="mb-8 text-12 text-on-surface-muted">
            {members.length} {members.length === 1 ? 'member' : 'members'}
          </p>
          {members.map((member) => (
            <TeamMemberRow key={member.id} member={member} />
          ))}
        </div>
      ) : (
        <p className="text-12 text-on-surface-muted">No team members found.</p>
      )}
    </DashboardCard>
  );
}
